import React from "react";
import { Helmet } from "react-helmet";
import "./src/styles/global.css";

export const onRenderBody = ({ setHeadComponents }) => {
  setHeadComponents([
    <Helmet key="google-analytics">
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-2QN9GTKGKW"
      ></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-2QN9GTKGKW');
        `}
      </script>
    </Helmet>,
  ]);
};
